export default {
    SELECT({commit}, payload) {
        commit('SELECT', payload)
    },
    RESET_RESEARCH({commit}, payload) {
        commit('RESET_RESEARCH', payload);
    },
    DELETE_CRITERIA({commit}, payload) {
        commit('DELETE_CRITERIA', payload);
    },
    DELETE_ALL_CRITERIA({commit}, payload) {
        commit('DELETE_ALL_CRITERIA', payload);
    },
};